export class Configuration {
  /***production links***/
  static baseUrl = "https://prodaja.lo.co.me";
  static apiUrl = `${Configuration.baseUrl}/mps_api`;
  /***test links***/
  //static baseUrl = "http://localhost";
  //static apiUrl = `${Configuration.baseUrl}/mps`
}
